/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useState } from 'react'
import { isMobile } from 'react-device-detect'

import { message } from 'antd'
import { Modal } from 'antd-mobile'
// icon
import { ChangeBtnIco } from '@shared/Icon/EtcIcon'
import { ModalBg } from '@styles/base.style'
import { Button, ButtonWrap, CloseBtn, ModalFooterWrap, PopupBtnStyle } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
import ItemShop from '@views/ItemShop'
import { PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import MyItem from '@views/MyItem'
import { VIEW_TYPE } from '@constants/index'
import { UserItem } from '@store/userStore'

interface SkinDrawerProps {
  visible: boolean
  setVisible: (arg: boolean) => void
}

const SkinDrawer: React.FC<SkinDrawerProps> = (props: SkinDrawerProps) => {
  const { visible, setVisible } = props
  const { userStore, routerStore, globalStore, authStore, logStore } = useRootStore()
  const [selectedUserItem, setSelectedUserItem] = useState<UserItem>(null)
  const [disableUseItem, setDisableUseItem] = useState(false)
  const { history } = routerStore

  const skinPropertyIds = [PROPERTY_ID.AVATAR]

  globalStore.updateVisibleModalList(visible, 'SkinDrawer:visible')

  const onClickCloseButton = () => {
    setVisible(false)
    globalStore.setVisibleChangeProfile(false)
  }

  const useItem = async () => {
    setDisableUseItem(true)
    await userStore.userUseItem({ itemId: selectedUserItem.id })
    message.info('스킨이 변경 되었습니다')
    authStore.changeUserAvatar(selectedUserItem.icon_m)
    setDisableUseItem(false)
    onClickCloseButton()
  }

  const onClickJumpSkinShopButton = () => {
    if (isMobile) {
      onClickCloseButton()
      history.push('/itemshop')
    } else {
      globalStore.addGeneralPopupProperties(<ItemShop />, '상점', {
        closeCallback: () => {
          logStore.writeButtonLog({ pageId: 'd020', buttonId: '001' }).catch(console.error)
        }
      })
    }
  }

  const setSelectedUserItemToParent = (selectItem: UserItem, selectItemCount: number): void => {
    setSelectedUserItem(selectItem)
  }

  return (
    <Fragment>
      <Modal
        popup
        maskClosable={false}
        onClose={onClickCloseButton}
        visible={visible}
        animated={isMobile}
        animationType="slide-up"
        title={
          <Fragment>
            <h1 className="title">보유중인 스킨</h1>
            <Button onClick={onClickCloseButton} className="close-btn" css={CloseBtn}>
              <span className="close-txt">닫기</span>
            </Button>
          </Fragment>
        }
        className="full-modal title-clear"
      >
        <MyItem
          propertyIds={skinPropertyIds}
          viewType={VIEW_TYPE.SKIN_SELECTOR}
          setSelectedUserItemToParent={setSelectedUserItemToParent} />
        <ModalFooterWrap css={{ position: 'absolute' }}>
          <ButtonWrap>
            <Button
              css={PopupBtnStyle}
              onClick={onClickJumpSkinShopButton}
              className="two-button cancel bottom-btn modal">
              스킨 구매하기
            </Button>
            <Button
              primary
              disabled={disableUseItem}
              onClick={useItem}
              css={PopupBtnStyle}
              className="two-button bottom-btn modal">
              <ChangeBtnIco />변경하기
            </Button>
          </ButtonWrap>
        </ModalFooterWrap>
        <ModalBg onClick={onClickCloseButton} />
      </Modal>
    </Fragment>
  )
}

export default observer(SkinDrawer)
